import { getToken, removeToken } from '../utils/auth';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000';

async function fetchWithAuth(url, options = {}) {
  const token = getToken();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
    },
    ...options,
  };

  console.log(`Making request to: ${url}`, config);

  try {
    const response = await fetch(`${API_BASE}${url}`, config);
    console.log(`Response status: ${response.status} for ${url}`);

    // Ak je status 401 alebo 403, používateľ nie je autorizovaný
    if (response.status === 401 || response.status === 403) {
      removeToken();
      // Vyhodíme chybu, ktorá bude ošetrená v komponente
      throw new Error(`${response.status} - Unauthorized`);
    }

    if (!response.ok) {
      const errorText = await response.text();
      console.error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      throw new Error(errorText || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log(`Response data for ${url}:`, data);
    return data;
  } catch (error) {
    console.error(`API call failed for ${url}:`, error);
    throw error;
  }
}

export async function login(email, password) {
  console.log('Login function called with:', { email, password });

  const response = await fetch(`${API_BASE}/api/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
  });

  console.log('Raw login response:', response);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Login failed' }));
    throw new Error(errorData.detail || 'Login failed');
  }

  const data = await response.json();
  console.log('Login successful, data:', data);
  return data;
}

export async function getDashboard() {
  return fetchWithAuth('/api/dashboard');
}

export async function getPackageLessons(packageId) {
  return fetchWithAuth(`/api/package/${packageId}/lessons`);
}

export async function getLectorSummary(lectorId) {
  return fetchWithAuth(`/api/lektor/${lectorId}/summary`);
}

export async function getPackageDetail(packageId) {
  return fetchWithAuth(`/api/package/${packageId}/detail`);
}

// Availability
export async function getAvailability() {
  return fetchWithAuth('/api/lecturer/availability');
}

export async function createAvailabilityBlock(availabilityData) {
  return fetchWithAuth('/api/lecturer/availability', {
    method: 'POST',
    body: JSON.stringify(availabilityData),
  });
}

export async function deleteAvailabilityBlock(blockId) {
  return fetchWithAuth(`/api/lecturer/availability/${blockId}`, {
    method: 'DELETE',
  });
}

// Unavailability
export async function getUnavailability() {
  return fetchWithAuth('/api/lecturer/unavailability');
}

export async function createUnavailabilityBlock(unavailabilityData) {
  return fetchWithAuth('/api/lecturer/unavailability', {
    method: 'POST',
    body: JSON.stringify(unavailabilityData),
  });
}

export async function deleteUnavailabilityBlock(blockId) {
  return fetchWithAuth(`/api/lecturer/unavailability/${blockId}`, {
    method: 'DELETE',
  });
}

export async function updateUnavailabilityBlock(blockId, unavailabilityData) {
  return fetchWithAuth(`/api/lecturer/unavailability/${blockId}`, {
    method: 'PUT',
    body: JSON.stringify(unavailabilityData),
  });
}

// Reservation settings
export async function getReservationSettings() {
  return fetchWithAuth('/api/lecturer/reservation-settings');
}

export async function updateReservationSetting(settingId, settingData) {
  return fetchWithAuth(`/api/lecturer/reservation-settings/${settingId}`, {
    method: 'PUT',
    body: JSON.stringify(settingData),
  });
}

// Recurring unavailability
export async function getRecurringUnavailability() {
  return fetchWithAuth('/api/lecturer/recurring-unavailability');
}

export async function createRecurringUnavailability(data) {
  return fetchWithAuth('/api/lecturer/recurring-unavailability', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updateRecurringUnavailability(blockId, data) {
  return fetchWithAuth(`/api/lecturer/recurring-unavailability/${blockId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

export async function deleteRecurringUnavailability(blockId) {
  return fetchWithAuth(`/api/lecturer/recurring-unavailability/${blockId}`, {
    method: 'DELETE',
  });
}

// Externé kalendáre
export async function getExternalCalendars() {
  return fetchWithAuth('/api/lecturer/external-calendars');
}

export async function createExternalCalendar(calendarEmail) {
  return fetchWithAuth('/api/lecturer/external-calendars', {
    method: 'POST',
    body: JSON.stringify({ calendar_email: calendarEmail }),
  });
}

export async function updateExternalCalendar(calendarId, data) {
  return fetchWithAuth(`/api/lecturer/external-calendars/${calendarId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

export async function deleteExternalCalendar(calendarId) {
  return fetchWithAuth(`/api/lecturer/external-calendars/${calendarId}`, {
    method: 'DELETE',
  });
}

export async function testExternalCalendar(calendarEmail) {
  return fetchWithAuth('/api/lecturer/external-calendars/test', {
    method: 'POST',
    body: JSON.stringify({ calendar_email: calendarEmail }),
  });
}

export async function verifyExternalCalendar(calendarId) {
  return fetchWithAuth(`/api/lecturer/external-calendars/${calendarId}/verify`, {
    method: 'POST',
  });
}